import { cn } from '@jeraisonne/ui';
import type { SchoolLevel } from '@jeraisonne/db';
import type { DecouverteProfile } from '@/features/decouverte/decouverte-profile';
import { DEMO_LEVELS, LEVEL_LABEL } from '../types';

/** La question posée selon le profil choisi à l'accueil (un parent choisit la classe de son enfant). PUR. */
export function levelQuestionFor(profile: DecouverteProfile | null): {
  title: string;
  text: string;
} {
  const end = 'guidé pas à pas sur la feuille de brouillon. Une minute, sans compte.';
  if (profile === 'parent')
    return {
      title: 'En quelle classe est ton enfant ?',
      text: `Un vrai exercice de sa classe, ${end}`,
    };
  if (profile === 'tutor' || profile === 'player')
    return {
      title: 'Quelle classe veux-tu essayer ?',
      text: `Un vrai exercice de cette classe, ${end}`,
    };
  return { title: 'En quelle classe es-tu ?', text: `Un vrai exercice de ta classe, ${end}` };
}

/**
 * Premier écran de la démo sans compte : la classe du visiteur, en un toucher. Puis la vraie question de démo de
 * cette classe, guidée pas à pas (`/demo`) — un 6e et un Terminale ne voient pas le même exercice.
 */
export function LevelSelectionScreen({
  onSelect,
  onSignup,
  profile = null,
}: {
  onSelect: (level: SchoolLevel) => void;
  onSignup: () => void;
  /** profil choisi à l'accueil `/decouverte` */
  profile?: DecouverteProfile | null;
}) {
  const q = levelQuestionFor(profile);
  return (
    <div className="mx-auto max-w-lg space-y-6" data-testid="demo-level">
      <header className="space-y-2">
        <h1 className="font-display text-ink-900 text-3xl font-extrabold leading-tight">
          {q.title}
        </h1>
        <p className="text-ink-600 text-[15px]">{q.text}</p>
      </header>
      <div role="group" aria-label="Classe" className="grid grid-cols-3 gap-2.5">
        {DEMO_LEVELS.map((level) => (
          <button
            key={level}
            type="button"
            onClick={() => onSelect(level)}
            className={cn(
              'border-ink-200 hover:border-primary-300 hover:bg-primary-50/40 ocean:bg-white/5 flex min-h-[3.25rem] items-center justify-center rounded-2xl border bg-white px-3 py-3 text-base font-bold transition-colors active:scale-[0.97]',
              level === 'tle' && 'col-span-3 sm:col-span-1',
            )}
          >
            {LEVEL_LABEL[level]}
          </button>
        ))}
      </div>

      <p className="text-ink-500 text-center text-sm">
        Déjà convaincu ?{' '}
        <button
          type="button"
          onClick={onSignup}
          className="text-primary-600 min-h-11 font-semibold underline-offset-4 hover:underline"
        >
          Créer mon compte gratuit
        </button>
      </p>
    </div>
  );
}
